import React, { forwardRef, useLayoutEffect, useRef } from 'react'
import { Editor as TinyMCEEditor } from '@tinymce/tinymce-react'

// ok, black magic time
// tinymce-react runs setContent after init, which we don't need
// because we set the content in the textarea
// so we need the first execution of setContent to do nothing
// or it will override the content from the textarea
TinyMCEEditor.prototype.originalInitEditor = TinyMCEEditor.prototype.initEditor
TinyMCEEditor.prototype.initEditor = function(initEvent, editor) {
  if (!editor || !editor.initialized || editor.removed || !editor.getBody()) {
    return
  }

  if (this.inline) {
    return TinyMCEEditor.prototype.originalInitEditor.apply(this, [
      initEvent,
      editor,
    ])
  }
  editor.originalSetContent = editor.setContent
  editor.setContent = function() {
    // First run of this function `editor.setContent` is a noop, the only thing
    // it does is reset setContent back to the original definition so that
    // subsequent runs work normally.
    editor.setContent = editor.originalSetContent
  }
  return TinyMCEEditor.prototype.originalInitEditor.apply(this, [
    initEvent,
    editor,
  ])
}

// This is a monkey patch to put the initialValue (if present)
// in the textarea, so it renders instantly
TinyMCEEditor.prototype.renderIframe = function() {
  var _this = this
  var value =
    typeof this.props.initialValue === 'string' ? this.props.initialValue : ''
  return React.createElement('textarea', {
    ref: function(elm) {
      return (_this.element = elm)
    },
    style: { visibility: 'hidden' },
    id: this.id,
    defaultValue: value,
  })
}

const Editor = forwardRef(function EditorWithRef(props, ref) {
  const editorComponentRef = useRef(null)

  useLayoutEffect(
    () => {
      if (typeof ref === 'function') ref(editorComponentRef.current)
      else if (ref) ref.current = editorComponentRef.current

      return () => {
        if (typeof ref === 'function') ref(null)
        else if (ref) ref.current = null
      }
    },
    [ref]
  )

  return <TinyMCEEditor {...props} ref={editorComponentRef} />
})

module.exports = {
  Editor,
}
